import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useForm } from 'react-hook-form'; 
import axios from 'axios';
import APIEndPoints from '../middleware/APIEndPoints';

const CustomerReviews = () => {
  const [services, setServices] = useState([]);
  const { register, handleSubmit, reset } = useForm();

    const baseUrl = APIEndPoints.services.url;


  useEffect(() => {
    // Fetch services from back-end
    axios.get(baseUrl)
      .then(response => {
        setServices(response.data);
      })
      .catch(error => {
        console.error('Error fetching services:', error);
      });
  }, []);

  const onSubmit = (data) => {
    console.log(data);
    
    reset();
  };

  return (
    <motion.div
      className="min-h-screen flex flex-col items-center justify-center bg-[#1d0c39] text-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Header Section */}
      <motion.h2 
        className="text-4xl font-bold mb-8"
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        Customer Reviews Form
      </motion.h2>

      {/* Form Section */}
      <motion.form
        onSubmit={handleSubmit(onSubmit)}
        className="w-full max-w-lg bg-[#2a1248] p-8 rounded-lg shadow-lg space-y-6"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: 'easeOut' }}
      >
        <div className="grid grid-cols-2 gap-4">
          {/* First Name */}
          <motion.div whileHover={{ scale: 1.05 }}>
            <label className="block text-sm font-bold mb-2">First Name</label>
            <input
              type="text"
              className="w-full p-2 rounded bg-[#422060] focus:ring-2 focus:ring-purple-500 focus:outline-none"
              {...register('firstName', { required: true })}
            />
          </motion.div>

          {/* Last Name */}
          <motion.div whileHover={{ scale: 1.05 }}>
            <label className="block text-sm font-bold mb-2">Last Name</label>
            <input
              type="text"
              className="w-full p-2 rounded bg-[#422060] focus:ring-2 focus:ring-purple-500 focus:outline-none"
              {...register('lastName', { required: true })}
            />
          </motion.div>
        </div>

        {/* Email Address */}
        <motion.div whileHover={{ scale: 1.05 }}>
          <label className="block text-sm font-bold mb-2">Email Address</label>
          <input
            type="email"
            className="w-full p-2 rounded bg-[#422060] focus:ring-2 focus:ring-purple-500 focus:outline-none"
            {...register('email', { required: true })}
          />
        </motion.div>

        {/* Phone Number */}
        <motion.div whileHover={{ scale: 1.05 }}>
          <label className="block text-sm font-bold mb-2">Phone Number</label>
          <input
            type="tel"
            className="w-full p-2 rounded bg-[#422060] focus:ring-2 focus:ring-purple-500 focus:outline-none"
            {...register('phone', { required: true })}
          />
        </motion.div>

        {/* Select Service */}
        <motion.div whileHover={{ scale: 1.05 }}>
          <label className="block text-sm font-bold mb-2">Select a Service</label>
          <select
            className="w-full p-2 rounded bg-[#422060] focus:ring-2 focus:ring-purple-500 focus:outline-none"
            {...register('service', { required: true })}
          >
            {services.length > 0 ? services.map(service => (
              <option key={service.id} value={service.name}>{service.name}</option>
            )) : <option>Loading...</option>}
          </select>
        </motion.div>

        {/* Message */}
        <motion.div whileHover={{ scale: 1.05 }}>
          <label className="block text-sm font-bold mb-2">Message</label>
          <textarea
            className="w-full p-2 rounded bg-[#422060] focus:ring-2 focus:ring-purple-500 focus:outline-none"
            rows="4"
            {...register('message', { required: true })}
          ></textarea>
        </motion.div>

        {/* Hire Me Button */}
        <motion.button
          type="submit"
          className="w-full py-3 rounded bg-purple-600 hover:bg-purple-800 font-bold text-lg"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Hire Me
        </motion.button>
      </motion.form>
    </motion.div>
  );
};

export default CustomerReviews;

